var React = require('react');

function IconAnalytics2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 3H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.675 2.675 0 0 0 24.333 3zm0 21.333H5.667V5.667h18.666zm-16-12H11v9.333H8.333zm5.333-4h2.667v13.334h-2.666zm5.333 8h2.667v5.333H19z","transform":"translate(-3 -3)"}));
}

IconAnalytics2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconAnalytics2;

IconAnalytics2.default = IconAnalytics2;
